module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-ExtraLightItalic.woff?65837db56704ac590b7086d3882398e3";